import moment from "moment-timezone";

const OSLO = "Europe/Oslo";

export const addOsloDays = (from: moment.MomentInput, days: number): string =>
  moment(from).tz(OSLO).add(days, "days").toISOString();

export const withOsloClockTimeOf = (dayIso: string, clockIso: string | null | undefined): string => {
  if (!clockIso) return dayIso;
  const clock = moment(clockIso).tz(OSLO);
  return moment(dayIso)
    .tz(OSLO)
    .set({ hour: clock.hour(), minute: clock.minute(), second: clock.second(), millisecond: clock.millisecond() })
    .toISOString();
};
